import React, {useState} from 'react';

import {
    Drawer,
    MenuHeader} from 'components';
import Information from 'module/client/Information';
import Teams from 'module/client/team/Teams';
import {useLayoutStore} from 'store';

const Client = ({client}) => {
    const [tab] = useState('teams');

    const closeMenu = useLayoutStore(state => state.closeMenu);
    const setShowClient = useLayoutStore(state => state.setShowClient);

    const goBack = () => {
        setShowClient(false);
    };

    return (
        <Drawer open={true} onClose={goBack}>
            <MenuHeader text={client.name} handleBackButton={goBack} handleClose={closeMenu} image={client.image} />

            {/* <Stack sx={styles.container} direction="column">
                <Stack sx={styles.avatarHolder}>
                    <Avatar sx={styles.avatar} alt={client.name} src={imageUrl(client.image, {w: 100, h: 100})}/>
                </Stack>
                <Stack sx={styles.headlineContainer}>
                    <Typography align="center">{client.name}</Typography>
                </Stack>
                <Stack sx={styles.tabContainer}>
                    <Tabs value={tab} onChange={(_e, tab) => setTab(tab)}>
                        <Tab value="teams" label={<Typography><Text>team.teams</Text></Typography>}/>
                        <Tab value="information" label={<Typography><Text>global.information</Text></Typography>}/>
                    </Tabs>
                </Stack>
            </Stack> */}

            {tab === 'teams' && <Teams client={client}/>}
            {tab === 'information' && <Information client={client}/>}

        </Drawer>
    );
};

export default Client;